import React from 'react';
import { _ } from '../../../functions/translator';

class CategoryInfo extends React.Component{

    render(){

        let categoryId = this.props.cardsGroup.attributes.card_category_id
        let category = null
        if (categoryId) {
            category = this.props.categories[categoryId.toString()]
        }
        let categoryName = category ? category.attributes.name : _('Ninguna')
        let cardColor = category ? category.attributes.color : 'black'

        
        const labelStyle = {
            "background-color" : cardColor
        }
        
        let categoryTitle = _("Categoría")
        if (this.props.customcard) {
            if (!this.props.customcard.attributes.card_category_id) return <div></div>
            categoryTitle = this.props.customcard.attributes.card_category_id
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ categoryTitle }</p>
                <span className='text card-description'>{ categoryName }</span>
                <div className="color-label" style={ labelStyle }></div>
            </div>
        );
    }
}

export default CategoryInfo;